export default __webpack_public_path__ + "static/media/user.9c746657.svg";